// "Temps active": the box beside Available MP / day on the Crew Schedule
// (#584). The box is TypedHeadcountBox, shared with Subcontractors (#688); what
// temps are, including that they are counted INSIDE Available MP, is
// TEMPS_ACTIVE in typedHeadcounts.ts.

import TypedHeadcountBox, { headcountDraftError, savedTypedHeadcount } from './TypedHeadcountBox';
import { TEMPS_ACTIVE } from './typedHeadcounts';

export { TEMPS_ACTIVE_KEY } from './typedHeadcounts';
export { parseHeadcount, saveFailureMessage, refusalMessage, type Rejected } from './TypedHeadcountBox';

/** Why a typed value isn't a headcount. See headcountDraftError. */
export const tempsDraftError = headcountDraftError;

/** The box's state for a value the API has just accepted. See savedTypedHeadcount. */
export const savedTempsActive = savedTypedHeadcount;

export default function TempsActiveBox(props: { availableMp: number | null; canEdit: boolean }) {
  return <TypedHeadcountBox figure={TEMPS_ACTIVE} {...props} />;
}
